import React, {useState, useEffect} from "react";
import {Button, Paper, Box, Autocomplete, TextField, Typography} from '@mui/material';
import Header from "../Common/Header/Header";
import Sidenav from "../Common/Sidenav/Sidenav";
import commonService from "../../services/common-service";
import Spinner from "../../shared/Spinner";
import SnackAlert from "../../shared/SnackAlert";
import { useParams } from "react-router-dom";

export default function VisitorPass() {
    const {domain} = useParams();
    const [installations, setInstallations] = useState([]);
    const [groups, setGroups] = useState([]);
    const [tariff, setTariff] = useState([]);
    const [visitorPassGrpt, setVisitorPassGrpt] = useState([]);
    const [inputField, setInputField] = useState({});
    const [selectedIns, setSelectedIns] = useState(null);
    const [selectedGrp, setSelectedGrp] = useState(null);
    const [selectedPass, setSelectedPass] = useState(null);
    const [spinner, setSpinner] = React.useState(false);
    const [alert, setAlert] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [severity, setSeverity] = React.useState('');
    const [lastIds, setLastIds] = useState({});
    
    const handleChange=(e) => {
        setInputField({...inputField, [e.target.name]: e.target.value});
    }

    const getInstalltions=async() => {
        setSpinner(true);
        const user = JSON.parse(sessionStorage.getItem('userLogged'));
        let body = {domain: domain};
        if(user.email == "cwpadmin"){
            body.ins_description = 'cwp'
        }
        const res = await commonService.visitor_pass_installations(body);
        setInstallations(res.data);
        setSpinner(false);
    }

    const onInsSelect=async(newValue) => {
        setSelectedIns(newValue);
        get_groups_by_ins_id(newValue.InstallationCode);
        get_group_types(newValue.InstallationCode);
    }

    const onPassSelect=async(newValue) => {
        setSelectedPass(newValue);
        setSpinner(true);
        const res = await commonService.get_tar_id_by_grpt({grpt_id: newValue.GRPT_ID, domain: domain});
        setTariff(res.data[0]);
        setSpinner(false);
    }

    const get_groups_by_ins_id=async(ins_id) => {
        setSpinner(true);
        const res = await commonService.get_groups_by_ins_id({ins_id: ins_id, domain: domain});
        setGroups(res.data);
        setSelectedGrp(null);
        setSpinner(false);
    }

    const get_group_types=async(ins_id) => {
        setSpinner(true);
        const res = await commonService.get_group_types({ins_id: ins_id, grpt_description: 'visitorpass', domain: domain});
        setVisitorPassGrpt(res.data);
        setSelectedPass(null);
        setSpinner(false);
    }

    const handleSubmit=async(e) => {
        e.preventDefault();
        setSpinner(true);
        let queryObj;
        let grptAssignation = "INSERT INTO [dbo].[GROUPS_TYPES_ASSIGNATIONS]([GTA_DESCRIPTION],[GTA_GRP_ID],[GTA_GRPT_ID],[GTA_INI_APPLY_DATE],[GTA_END_APPLY_DATE] ,[GTA_MAIN])\n"+
        "VALUES ('"+selectedPass.GRPT_DESCRIPTION+"', "+selectedGrp.grp_id+", "+selectedPass.GRPT_ID+", '2013-01-01 00:00:00.000', '2030-01-01 00:00:00.000', '0');";
        queryObj = {
            grptAssignation: grptAssignation
        };
        Object.keys(queryObj).map(function(key, index) {
            queryObj[key] = queryObj[key].replace(/\n/g, '');
        });
        queryObj['domain'] = domain;
        const res = await commonService.insert_to_db(queryObj);
        if(res.data == true){
            insert_to_visitorpass();
        }else{
            let result = res.data.split('</div>');
            let errArray = JSON.parse(result[result.length-1].replace('\n',''));
            setMsg(errArray.map(x=>{return x}).join('\n\n'))
            setSeverity('error');
        }
        setAlert(true);
        setSpinner(false);
    }

    const insert_to_visitorpass=async() => {
        setSpinner(true);
        let queryObj;
        let group = "INSERT INTO [dbo].[ParkingZones]([Name],[ZoneCode],[InstallationId],[FreeHours])\n"+
            "VALUES('" + selectedGrp.GRP_DESCRIPTION + "'," + selectedGrp.grp_id + "," + selectedIns.Id + ",'" + getDurationMinutes(selectedPass.GRPT_DESCRIPTION, false) + "');";
        queryObj = {
            group: group,
        };
        Object.keys(queryObj).map(function(key, index) {
            queryObj[key] = queryObj[key].replace(/\n/g, '');
        });
        const res = await commonService.insert_to_visitorpass(queryObj);
        if(res.data.success == true){
            let queryOptionObj;
            let option = "INSERT INTO [dbo].[ParkingOptions]([Name],[ZoneId],[Hours],[OptionCode],[Rate])\n"+
            "VALUES('Max " + getDurationMinutes(selectedPass.GRPT_DESCRIPTION, true) + " $0 Blinkay',"+res.data?.insert_ids?.[0]+",'" + getDurationMinutes(selectedPass.GRPT_DESCRIPTION, false) + "','" + tariff.TAPR_TAR_ID + "',0)"
            queryOptionObj = {
                option: option
            };
            Object.keys(queryOptionObj).map(function(key, index) {
                queryOptionObj[key] = queryOptionObj[key].replace(/\n/g, '');
            });
            const optionRes = await commonService.insert_to_visitorpass(queryOptionObj);
            if(optionRes.data.success == true){
                setMsg("Visitor Pass Added Successfully");
                setSeverity('success');
                setSelectedPass(null);
            }else{
                let result = optionRes.data.split('</div>');
                let errArray = JSON.parse(result[result.length-1].replace('\n',''));
                setMsg(errArray.map(x=>{return x}).join('\n\n'))
                setSeverity('error');
            }
        }else{
            let result = res.data.split('</div>');
            let errArray = JSON.parse(result[result.length-1].replace('\n',''));
            setMsg(errArray.map(x=>{return x}).join('\n\n'))
            setSeverity('error');
        }
        setAlert(true);
        setSpinner(false);
    }

    function getDurationMinutes(description, showDuration) {
        const text = description.toLowerCase();

        // 30min -> 30
        let match = text.match(/(\d+(?:[.,]\d+)?)\s*min/);
        if (match) {
            if(showDuration)
                return parseFloat(match[1].replace(',', '.')) + ' min';
            else
                return parseFloat(match[1].replace(',', '.'));
        }

        // 0.5h, 0,5h, 4h, 4hr, 4 hrs
        match = text.match(/(\d+(?:[.,]\d+)?)\s*(h|hr|hrs|hour|hours)\b/);
        if (match) {
            if(showDuration)
                return parseFloat(match[1].replace(',', '.')) + ' Hours';
            else
                return parseFloat(match[1].replace(',', '.'));
        }

        return null;
    }

    useEffect(()=>{
        getInstalltions();
    },[])

    return (
        <div>
            <Header />
            <div className="main-container my-3">
                <div className="row m-2">
                    <div className="col-lg-2 col-xl-2 d-none d-lg-block d-xl-block">
                        <Sidenav/>
                    </div>
                    <div className="col-lg-10 col-xl-10">
                        <Paper elevation={2} sx={{ width: '100%', p: 3}}>
                            <Typography variant="body1" className="font-bold">Visitor Pass</Typography>
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className='col-lg-6'>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={installations}
                                            getOptionLabel={(option) => option.Description}
                                            name="selectedIns"
                                            value={selectedIns}
                                            onChange={(event, newValue)=>onInsSelect(newValue)}
                                            renderInput={(params) =>
                                            <TextField 
                                                {...params} id="standard-basic" 
                                                label="City" variant="standard" 
                                                className="width-90" 
                                                required
                                            />}
                                    />
                                    </div>
                                    <div className='col-lg-6'>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={groups}
                                            getOptionLabel={(option) => option.GRP_DESCRIPTION + " - " + option.grp_id}
                                            name="selectedIns"
                                            value={selectedGrp}
                                            onChange={(event, newValue)=>setSelectedGrp(newValue)}
                                            renderInput={(params) =>
                                            <TextField 
                                                {...params} id="standard-basic" 
                                                label="Zone" variant="standard" 
                                                className="width-90" 
                                                required
                                            />}
                                    />
                                    </div>
                                    <div className='col-lg-6'>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={visitorPassGrpt}
                                            getOptionLabel={(option) => option.GRPT_DESCRIPTION}
                                            name="selectedIns"
                                            value={selectedPass}
                                            onChange={(event, newValue)=>onPassSelect(newValue)}
                                            renderInput={(params) =>
                                            <TextField 
                                                {...params} id="standard-basic" 
                                                label="Visitor Pass" variant="standard" 
                                                className="width-90" 
                                                required
                                            />}
                                    />
                                    </div>
                                </div>
                                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                    <Box sx={{ flex: '1 1 auto' }} />
                                    <Button type="button" className="me-2" onClick={()=>{window.location.reload()}}>
                                        Reset
                                    </Button>
                                    <Button type="submit" className="btn btn-blue px-3 fit-content">
                                        Add Visitor Pass
                                    </Button>
                                </Box>
                            </form>
                        </Paper>
                    </div>
                </div>
            </div>
            <Spinner
                spinner = {spinner}
            />
            <SnackAlert 
                msg={msg}
                alert={alert}
                severity={severity}

                closeAlert={()=>setAlert(false)}
            />
        </div>
    );
}
